import { RedoMarketingRpcClientContext } from "@redotech/redo-merchant-app-common/marketing-rpc-client-provider";
import type { ShopperAgentSettingsForResolution } from "@redotech/redo-shopper-agent-common/resolve-trigger-config";
import { useRpcQuery } from "@redotech/redo-web/rpc-query/use-rpc-query";

/**
 * Settings as published, for surfaces that report on the agent rather than
 * edit it. Null published config means the agent is off.
 */
export function usePublishedShopperAgentSettings(): {
  settings: ShopperAgentSettingsForResolution | undefined;
  isLoading: boolean;
  refetch: () => Promise<unknown>;
} {
  const query = useRpcQuery(RedoMarketingRpcClientContext, {
    method: "getPublishedShopperAgentSettings",
    args: {},
  });

  return {
    settings: query.data?.settings ?? undefined,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
